import React, { useEffect, useState } from "react";
import axios from "axios";
import RazorpayManager from "../components/razorpay/RazorpayManager";

const Settings = () => {
  const [formData, setFormData] = useState({
    siteName: "",
    contactEmail: "",

    privacyPolicyUrl: "",
    termsUrl: "",
    communityGuidelinesUrl: "",
    coinPolicyUrl: "",
    aboutUsUrl: "",

    agoraAppId: "",
    agoraAppCertificate: "",

    cloudinaryCloudName: "",
    cloudinaryApiKey: "",
    cloudinaryApiSecret: "",

    razorpayKeyId: "",
    razorpayKeySecret: "",

    smsApiKey: "",

    androidMinimumVersionCode: "1",
    androidLatestVersionName: "",
    forceAndroidUpdate: false,
    playStoreUrl: "",
  });

  const inputStyle =
    "w-full px-3 py-2 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400";

  // ✅ Fetch settings
  const fetchSettings = async () => {
    try {
      const res = await axios.get("/api/v1/admin/site-settings/view-site-settings");

      if (res.data.success && res.data.data) {
        // setFormData({ ...formData, ...res.data.data });
       
        setFormData(prev => ({
  ...prev,
  ...res.data.data
}));

      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // ✅ Handle change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  // ✅ Save settings
  const saveSettings = async () => {
    try {
      const res = await axios.post(
        "/api/v1/admin/site-settings/add-or-update-site-settings",
        formData
      );

      if (res.data.success) {
        alert("Settings saved successfully!");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  return (
    <div className="p-6 bg-white min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Site Settings</h1>

      <div className="space-y-6">

        {/* GENERAL */}
        <Section title="General">
          

          <Field label="Contact Email">
            <input name="contactEmail" value={formData.contactEmail}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* LINKS */}
        <Section title="Policy Links">
          <Field label="Privacy Policy URL">
            <input name="privacyPolicyUrl" value={formData.privacyPolicyUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Terms & Conditions URL">
            <input name="termsUrl" value={formData.termsUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Community Guidelines URL">
            <input name="communityGuidelinesUrl"
              value={formData.communityGuidelinesUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Coin Policy URL">
            <input name="coinPolicyUrl" value={formData.coinPolicyUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="About Us URL">
            <input name="aboutUsUrl" value={formData.aboutUsUrl}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* AGORA */}
        <Section title="Agora Config">
          <Field label="Agora App ID">
            <input name="agoraAppId" value={formData.agoraAppId}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Agora Certificate">
            <input name="agoraAppCertificate"
              value={formData.agoraAppCertificate}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* CLOUDINARY */}
        <Section title="Cloudinary">
          <Field label="Cloud Name">
            <input name="cloudinaryCloudName"
              value={formData.cloudinaryCloudName}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="API Key">
            <input name="cloudinaryApiKey"
              value={formData.cloudinaryApiKey}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="API Secret">
            <input  name="cloudinaryApiSecret"
              value={formData.cloudinaryApiSecret}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* RAZORPAY */}
        <Section title="Razorpay">
          <Field label="Key ID">
            <input name="razorpayKeyId"
              value={formData.razorpayKeyId}
              onChange={handleChange} className={inputStyle} />
          </Field>

          <Field label="Key Secret">
            <input type="password" name="razorpayKeySecret"
              value={formData.razorpayKeySecret}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* SMS */}
        <Section title="SMS">
          <Field label="SMS API Key">
            <input name="smsApiKey"
              value={formData.smsApiKey}
              onChange={handleChange} className={inputStyle} />
          </Field>
        </Section>

        {/* ANDROID FORCE UPDATE */}
        <Section title="Android Force Update">
          <p className="text-sm text-gray-600">
            Enter the Android version code from the Google Play release. When enabled,
            all lower-version app builds must update before they can continue.
          </p>

          <Field label="Minimum Android Version Code">
            <input
              type="number"
              min="1"
              step="1"
              name="androidMinimumVersionCode"
              value={formData.androidMinimumVersionCode}
              onChange={handleChange}
              className={inputStyle}
              required
            />
          </Field>

          <Field label="Latest Version Name (shown to users, e.g. 1.4.0)">
            <input
              name="androidLatestVersionName"
              value={formData.androidLatestVersionName}
              onChange={handleChange}
              className={inputStyle}
            />
          </Field>

          <Field label="Google Play Store URL">
            <input
              type="url"
              name="playStoreUrl"
              placeholder="https://play.google.com/store/apps/details?id=..."
              value={formData.playStoreUrl}
              onChange={handleChange}
              className={inputStyle}
            />
          </Field>

          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              name="forceAndroidUpdate"
              checked={formData.forceAndroidUpdate}
              onChange={handleChange}
              className="h-4 w-4"
            />
            <span className="text-sm font-medium">Require update for older Android app versions</span>
          </label>
        </Section>

        <button
          onClick={saveSettings}
          className="bg-pink-700 px-6 py-3 rounded-lg font-semibold w-full"
        >
          Save Settings
        </button>

      </div>
      {/* <RazorpayManager/> */}
    </div>
  );
};

// ✅ Reusable Components
const Section = ({ title, children }) => (
  <div className="border p-4 rounded-lg space-y-4">
    <h2 className="font-semibold text-lg">{title}</h2>
    {children}
  </div>
);

const Field = ({ label, children }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    {children}
  </div>
);

export default Settings;
